import { COST_SIMULATION_YEARS } from "@repo/shared";

// Local translations
export const T = {
  en_GB: {
    showHoldingPeriod: "Show holding-period column",
    showHoldingPeriodDesc:
      'Adds an "After N years" column next to the "After 1 year" figures (MiFID II holding-period cost disclosure).',
    holdingPeriodYears: "Holding period (years)",
    holdingPeriodYearsDesc: `Between 2 and ${COST_SIMULATION_YEARS} years.`,
  },
  nb_NO: {
    showHoldingPeriod: "Vis kolonne for investeringsperioden",
    showHoldingPeriodDesc:
      'Legger til en "Etter N år"-kolonne ved siden av tallene for "Etter 1 år" (MiFID II kostnadsopplysning for investeringsperioden).',
    holdingPeriodYears: "Investeringsperiode (år)",
    holdingPeriodYearsDesc: `Mellom 2 og ${COST_SIMULATION_YEARS} år.`,
  },
} as const;
